import React from 'react';
import PropTypes from 'prop-types';
import { Button, FormControl, Grid } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import {
  SearchDropdown, HealthChart, ColorIndicators, Skeleton, FormField,
} from '@iris-platform/iris-react-ui';
import classNames from 'classnames';
import Call from '@material-ui/icons/Call';
import { Query } from 'react-apollo';
import {
  equals,
  isEmpty,
} from 'ramda';
import Details from '@material-ui/icons/Details';
import Panel from '../Panel';
import CallDetails from './CallDetails';
import DateFilter from './DateFilterCard';
import { GET_CALLS, GET_CALL_STATISTICS_ALL, getAllApplications } from './queries';
import { isEmail } from '../../utils/validations';
import { TeamContext } from '../TeamProvider';

const styles = theme => ({
  root: {
    opacity: '1',
    backgroundColor: '#fff',
    marginTop: '0 !important',
    border: '1px solid #ccc',
    '&:focus-within': {
      border: '1px solid #66afe9',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
  panelHeader: {
    position: 'relative',
  },
  title: {
    display: 'block',
  },
  btn: {
    marginTop: '20px',
  },
  formControl: {
    margin: theme.spacing.unit,
    width: '100%',
    flexDirection: 'row',
    fontSize: '14px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
  },
  formFieldWrapper: {
    width: 350,
    display: 'inline-block',
    margin: '0 10px',
  },
  searchBtn: {
    width: 200,
    textAlign: 'center',
    marginLeft: '30px',
    marginTop: '-8px',
  },
  healthIndicesWrapper: {
    margin: '10px 5px',
    textAlign: 'right',
  },

  selectDropdown: {
    display: 'inline-block',
    width: 350,
    margin: '0 10px',
  },
  search: {
    padding: 0,
  },
  searchIcon: {
    top: '10px',
    right: '4px',
    color: '#ccc',
  },
  searchInput: {
    border: '1px solid #ccc',
  },
  iconStyles: {
    fill: '#1682bc',
  },
});


class CallStatisticsData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneNumber: '',
      phone: '',
      pendingChanges: false,
      networkSelected: false,
      phoneSelected: false,
    };
  }

  compress = (pn) => {
    const regex = /[-(). ]/g;
    return pn.replace(regex, '');
  }

  onChangeInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  onSearchCalls = () => {
    const { phoneNumber } = this.state;
    const { onSearchCallsByNumber } = this.props;

    let destPhoneNumber = phoneNumber;
    if (!isEmail(phoneNumber)) {
      if (phoneNumber.match(/^\d/) && !phoneNumber.includes('+1')) {
        destPhoneNumber = this.compress(`+1${phoneNumber}`);
      }
    }
    this.setState({ phone: destPhoneNumber, phoneNumber: destPhoneNumber });
    onSearchCallsByNumber(phoneNumber);
  }

  getOwner = () => {
    const { env } = this.props;

    return equals(undefined, env)
      ? TeamContext.getSelectedTeamId()
      : 'allApplications';
  };

  timeConverter(unixTime) {
    const myDate = new Date(unixTime);
    return myDate.toGMTString();
  }

  render() {
    const {
      classes, networkOptions, getTransformedData, env,
    } = this.props;
    const {
      pendingChanges,
      networkSelected,
      phoneSelected,
      phoneNumber,
    } = this.state;
    return (
    // <div className={classes.pageWtrapper}>
      <Panel
        id="callDetailsReport"
        title={(
          <div className={classes.panelHeader}>
              Call Search
            <DateFilter onClickDateFilter={this.props.onClickDateFilter} />
          </div>
          )}
        classes={{ title: classes.title }}
        avatar={<Call className={classes.iconStyles} />}
      >
        <FormControl className={classes.formControl}>
          <Query
            query={getAllApplications}
            notifyOnNetworkStatusChange
            fetchPolicy="network-only"
            variables={{
              filter: '', skip: 0, limit: 0, owner: this.getOwner(),
            }}
          >
            {({ data, loading, error }) => {
              let apps;
              if (error) {
                return <h3>Unable to get application list</h3>;
              }
              if (!(isEmpty(data))) {
                apps = data.allApplications.applications.map((app) => {
                  if (app.fields.childAppName !== '') return { description: `${app.fields.applicationName} - ${app.fields.childAppName}`, code: app.fields.domain };
                  return ({ description: `${app.fields.applicationName}`, code: app.fields.domain });
                });
              }
              return (
                data && !loading
                  ? (
                    <SearchDropdown
                      id="callStatsSearchDropdown"
                      classes={{
                        root: classes.selectDropdown,
                        search: classes.search,
                        searchInput: classes.searchInput,
                        searchIcon: classes.searchIcon,
                      }}
                      optionsList={apps}
                      placeholder="Select Client"
                      onSelect={(event) => {
                        this.props.handleChangeOperator(event);
                        this.setState({ networkSelected: true });
                      }}
                    />
                  )
                  : <Skeleton />);
            }}
          </Query>

          <FormField
            placeholder="Enter Phone number to search"
            id="phone"
            name="phoneNumber"
            classes={{ root: classes.root, formFieldWrapper: classes.formFieldWrapper }}
            className={classes.searchBox}
            value={phoneNumber}
            onChange={(event) => {
              this.onChangeInput(event);
              this.setState({ phoneSelected: true });
            }}
          />
          <Button className={classes.searchBtn} disabled={!networkSelected || !phoneSelected} onClick={this.onSearchCalls}>Search</Button>
        </FormControl>
        {this.props.searchValues.selectedDomain
          && this.props.searchValues.startTime
          && this.props.searchValues.endTime
          && this.state.phone
            && (
              <Query
                query={GET_CALLS}
                fetchPolicy="network-only"
                notifyOnNetworkStatusChange
                variables={{
                  appDomain: this.props.searchValues.selectedDomain,
                  startTime: String(this.props.searchValues.startTime),
                  endTime: String(this.props.searchValues.endTime),
                  identifier: this.state.phone,
                }}
              >
                {({ data, loading, error }) => {
                  if (error) {
                    return (
                      <h3>
                        Unable to find traceIDs for the number
                        { ' ' }
                        {this.state.phone}
                        { ' ' }
                        between
                        { ' ' }
                        {this.timeConverter(this.props.searchValues.startTime)}
                        { ' ' }
                         and
                        { ' ' }
                        {this.timeConverter(this.props.searchValues.endTime)}
                      </h3>
                    );
                  }
                  return (
                    data && !loading && Array.isArray(data.getCalls)
                      ? (
                        <Grid item xs={12}>
                          <CallDetails
                            callDetailsData={data.getCalls}
                            startTime={this.props.searchValues.startTime}
                            endTime={this.props.searchValues.endTime}
                          />
                        </Grid>
                      )
                      : <Skeleton />);
                }}
              </Query>
            )}
      </Panel>
    );
  }
}

CallStatisticsData.propTypes = {
  onSearchCallsByNumber: PropTypes.func.isRequired,
};

export default withStyles(styles)(CallStatisticsData);
